// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1OPyV","productName":"Table_productName__11Oip"};